import { ReactNode } from 'react';

export interface EmptyStateProps {
  /** Sets the style skin for the empty state
   * @default 'section'
   */
  skin?: EmptyStateSkin;
  /** @deprecated use skin prop instead */
  theme?: EmptyStateSkin;
  /** Sets the content for the title */
  title?: string | ReactNode;
  /** Sets the content for the subtitle */
  subtitle?: string | ReactNode;
  /** Contains the empty state image. Can be either a string representing the image URL, or a node to render. */
  image?: string | React.ReactElement | null;
  /** Contains components rendered below the subtitle, e.g., `<Button/>` or `<TextButton/>` */
  children?: ReactNode;
  /** Sets the empty state image bottom margin. If not specified, use the default padding defined in the CSS. */
  classNames?: { imageContainer?: string };
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook?: string;
  /** Sets the alignment of all empty state contents within the component container
   * @default 'center'
   */
  align?: EmptyStateAlign;
  /**
   * Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
}

export declare const defaultEmptyStateProps: EmptyStateProps;

export type EmptyStateSkin = 'page' | 'page-no-border' | 'section';
export type EmptyStateTheme = EmptyStateSkin;
export type EmptyStateAlign = 'start' | 'center' | 'end';
